import type { KeyboardEvent } from 'react';
import { ArrowRightIcon, TowTruckIcon } from '@rsos/assets/icons';
import styles from './TowProCard.module.css';

interface TowProCardProps {
  /** Called when the card is clicked or activated from the keyboard. */
  onClick: () => void;
}

/**
 * Tools-tab card for requesting a tow through TowPro. Unlike the Air
 * Ambulance card there is no overview-tab variant; tows are requested from
 * the overview tab through the generic Request Resources card.
 */
const TowProCard = ({ onClick }: TowProCardProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={styles.card}
      data-name="tools-towpro-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Request a tow"
    >
      <div className={styles.row}>
        <div className={styles.info}>
          <div className={styles.titleRow}>
            <TowTruckIcon
              aria-hidden
              color="primaryText"
              height={12}
              width={12}
            />
            <span className={styles.title} data-name="tools-towpro-card-title">
              Tow
            </span>
          </div>
          <span
            className={styles.subtitle}
            data-name="tools-towpro-card-subtitle"
          >
            Local Rotation Providers
          </span>
        </div>
        <div
          className={styles.arrowIcon}
          data-name="tools-towpro-card-icon"
          aria-hidden
        >
          <ArrowRightIcon color="secondaryText" height={20} width={22} />
        </div>
      </div>
    </div>
  );
};

export default TowProCard;
